import { render, staticRenderFns } from "./NkChartPre.vue?vue&type=template&id=2f72dac7&scoped=true"
import script from "./NkChartPre.vue?vue&type=script&lang=js"
export * from "./NkChartPre.vue?vue&type=script&lang=js"
import style0 from "./NkChartPre.vue?vue&type=style&index=0&id=2f72dac7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72dac7",
  null
  
)

export default component.exports